module.exports = __webpack_public_path__ + "media/images/icons/mail-d5000481c08893e84931297a3988beda.svg";